var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            modalId: "remove-apparatuses-selection-modal",
            size: "modal-lg"
          },
          on: {
            hidden: function($event) {
              return _vm.closeRemovalModals()
            }
          }
        },
        [
          _c("ModalHeader", {
            attrs: {
              title: _vm.$t("xSelectProductsToRemove"),
              icon: "far fa-badge-dollar colorOrange mr-1"
            }
          }),
          _c("ModalBody", [
            _vm.showRemoveError
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-danger",
                    attrs: { role: "alert" }
                  },
                  [
                    _c("p", { staticClass: "mb-2" }, [
                      _c("i", {
                        staticClass: "far fa-circle-exclamation mr-1"
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("xSomethingWentWrong")) + " ")
                    ]),
                    _c("p", { staticClass: "ml-4" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("xPleaseWaitAndTryAgain")) + " "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "col mb-4" }, [
              _c("p", [
                _c("b", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("xSelectProductsToRemoveWarningText1")) +
                      " "
                  )
                ]),
                _vm._v(
                  " " +
                    _vm._s(" ") +
                    " " +
                    _vm._s(_vm.$t("xSelectProductsToRemoveWarningText2")) +
                    " "
                )
              ])
            ]),
            _vm.subscriptionGenerators && _vm.subscriptionGenerators.length > 0
              ? _c("div", { staticClass: "mb-4" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex align-items-center mb-2" },
                    [
                      _c("b-img", {
                        staticClass: "mr-2",
                        attrs: { src: require("@/assets/images/generator.svg") }
                      }),
                      _c("strong", [
                        _vm._v(" " + _vm._s(_vm.$t("xGenerators")) + " ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    _vm._l(_vm.subscriptionGenerators, function(generator) {
                      return _c(
                        "div",
                        {
                          key: generator.id,
                          staticClass: "custom-control custom-checkbox mb-3"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.apparatusesToRemove,
                                expression: "apparatusesToRemove"
                              }
                            ],
                            staticClass: "custom-control-input",
                            class: _vm.checkboxStatus(
                              _vm.$v.apparatusesToRemove
                            ),
                            attrs: { id: generator.id, type: "checkbox" },
                            domProps: {
                              value: generator,
                              checked: Array.isArray(_vm.apparatusesToRemove)
                                ? _vm._i(_vm.apparatusesToRemove, generator) >
                                  -1
                                : _vm.apparatusesToRemove
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.apparatusesToRemove,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = generator,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.apparatusesToRemove = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.apparatusesToRemove = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.apparatusesToRemove = $$c
                                }
                              }
                            }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "custom-control-label",
                              attrs: { for: generator.id }
                            },
                            [_vm._v(" " + _vm._s(generator.name) + " ")]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm.subscriptionTanks && _vm.subscriptionTanks.length > 0
              ? _c("div", { staticClass: "mb-4" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex align-items-center mb-2" },
                    [
                      _c("b-img", {
                        staticClass: "mr-2",
                        attrs: { src: require("@/assets/images/tank.svg") }
                      }),
                      _c("strong", [
                        _vm._v(" " + _vm._s(_vm.$t("xFuelMonitors")) + " ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    _vm._l(_vm.subscriptionTanks, function(tank) {
                      return _c(
                        "div",
                        {
                          key: tank.id,
                          staticClass: "custom-control custom-checkbox mb-3"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.apparatusesToRemove,
                                expression: "apparatusesToRemove"
                              }
                            ],
                            staticClass: "custom-control-input",
                            class: _vm.checkboxStatus(
                              _vm.$v.apparatusesToRemove
                            ),
                            attrs: { id: tank.id, type: "checkbox" },
                            domProps: {
                              value: tank,
                              checked: Array.isArray(_vm.apparatusesToRemove)
                                ? _vm._i(_vm.apparatusesToRemove, tank) > -1
                                : _vm.apparatusesToRemove
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.apparatusesToRemove,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = tank,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.apparatusesToRemove = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.apparatusesToRemove = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.apparatusesToRemove = $$c
                                }
                              }
                            }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "custom-control-label",
                              attrs: { for: tank.id }
                            },
                            [_vm._v(" " + _vm._s(tank.name) + " ")]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm.showErrorMessage
              ? _c("div", [
                  _c("div", { staticClass: "col" }, [
                    _c("p", { staticClass: "text-small colorRed" }, [
                      _vm._v(_vm._s(_vm.errorMessageText))
                    ])
                  ])
                ])
              : _vm._e()
          ]),
          _c("ModalFooter", [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-warning",
                on: {
                  click: function($event) {
                    return _vm.closeRemovalModals()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-warning",
                on: {
                  click: function($event) {
                    return _vm.removeSelectedApparatuses()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xRemoveProductsButtonText")) + " ")]
            )
          ])
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { modalId: "remove-products-modal", size: "modal-md" },
          on: {
            hidden: function($event) {
              return _vm.closeRemovalModals()
            }
          }
        },
        [
          _c(
            "ModalHeader",
            {
              attrs: {
                title: _vm.$t("xRemoveProductsButtonText"),
                icon: "fa-light fa-triangle-exclamation mr-1"
              }
            },
            [
              _c("div", { staticClass: "cols-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-icon-button btn-icon-button--gray",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.closeRemovalModals()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]
          ),
          _c("ModalBody", [
            _c("div", { staticClass: "mb-4" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("xRemoveProductsLoseAccess")))])
            ]),
            _c(
              "ul",
              { staticClass: "mb-4 ml-n3" },
              _vm._l(_vm.apparatusesToRemove, function(apparatus) {
                return _c("li", { key: apparatus.id, staticClass: "mb-1" }, [
                  _vm._v(" " + _vm._s(apparatus.name) + " ")
                ])
              }),
              0
            ),
            _c("div", [
              _c("p", [_vm._v(_vm._s(_vm.$t("xRemoveProductsConfirmation")))])
            ])
          ]),
          _c("ModalFooter", [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-warning flex flex-grow-1",
                on: {
                  click: function($event) {
                    return _vm.closeRemovalModals()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xNoCancelButtonText")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-warning flex flex-grow-1",
                on: {
                  click: function($event) {
                    return _vm.removeProducts()
                  }
                }
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("xYesRemoveProductsButtonText")) + " "
                )
              ]
            )
          ])
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            modalId: "removing-products-spinner-modal",
            size: "modal-lg"
          }
        },
        [
          _c(
            "ModalBody",
            {
              staticStyle: { "padding-top": "100px", "padding-bottom": "100px" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center"
                },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "10rem", height: "10rem" },
                    attrs: { variant: "warning" }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }